
export default {
    meeting: {},
    twilioToken: null,
    otherUser: {},
    feedbackModal: {
        active: false
    },
    status: null, // pending, processing, done
    canReview: false,
    tipsThankyou: false
}
